import { render, staticRenderFns } from "./NewsLook.vue?vue&type=template&id=50579bc4&scoped=true&"
import script from "./NewsLook.vue?vue&type=script&lang=js&"
export * from "./NewsLook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50579bc4",
  null
  
)

export default component.exports